import { option } from './option';

export const minimum = {
  option,
};
